import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { CartAbandonmentReminderService } from './cart-abandonment-reminder.service';
import { EmailService } from './email.service';
import { TemplateRenderService } from './template-render.service';
import { WishlistReminderService } from './wishlist-reminder.service';

@Module({
  providers: [
    EmailService,
    TemplateRenderService,
    PrismaService,
    WishlistReminderService,
    CartAbandonmentReminderService,
  ],
  exports: [EmailService, TemplateRenderService],
})
export class NotificationsModule {}
